module.exports = __webpack_public_path__ + "static/img/empty-icon.397c965e.png";